import React, { Component } from 'react';
import Slider from 'react-slick';
import ScrollAnimation from 'react-animate-on-scroll';
import { dashboardCarousel } from '../../data/data';

class HomeCarousel extends Component {
  render() {
    return (
      <div id="home">
        <div className="homecarousel bg-gradient">
          <div className="align-items-center justify-content-center">
            <div style={{}} className="container">
              <div className="row">
                <div className="col-lg-12">
                  <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                    <Slider {...dashboardCarousel}>
                      <div>
                        <p className="title">Implement 4x faster. Reduce costs by 80%</p>
                        <p className="mb--0">
                          Increase Business Agility & Interoperability. Noctil's Platform
                          makes integration easy and fast.
                        </p>
                        <p className="mb--0">
                          Customers are able to ship code and deliver capabilities 4x
                          faster with a savings of 80%.
                        </p>
                        <p>
                          It reduces the need for custom code, allows you to support
                          in-house data models, and transform and export data in formats
                          that make you interoperable with all your partners.
                        </p>
                        <div className="image-wrapper">
                          <img
                            src="/assets/images/home-carousel/home-carousel-1.svg"
                            alt="Noctil-Improve royalty distribution accuracy up to 98%"
                          />
                        </div>
                      </div>
                      <div>
                        <p className="title">
                          Supercharge your Matching & Distribution Rates
                        </p>
                        <p className="mb--0">
                          Learn how the Noctil platform improved data quality and matching
                          resulting in a 98% increase in royalty payouts.
                        </p>
                        <p>
                          MatchIQ's configurable and extensible matching & deduplication
                          rules engine helped one customer setup custom matching rules
                          across repertoire, audiovisual works, playlists and performers
                          for complex matching and catalog management - all in 6 weeks.
                        </p>
                        <p className="mb--0" style={{ visibility: 'hidden' }}>
                          .
                        </p>
                        <div className="image-wrapper">
                          <img
                            src="/assets/images/home-carousel/home-carousel-2.svg"
                            alt="Noctil-Improve royalty distribution accuracy up to 98%"
                          />
                        </div>
                      </div>
                    </Slider>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default HomeCarousel;
